export default __webpack_public_path__ + "static/media/cutEsim.a3a23e2d.png";